import { render, staticRenderFns } from "./contextmenu.vue?vue&type=template&id=fbb1c556&scoped=true"
import script from "./contextmenu.vue?vue&type=script&lang=js"
export * from "./contextmenu.vue?vue&type=script&lang=js"
import style0 from "./contextmenu.vue?vue&type=style&index=0&id=fbb1c556&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb1c556",
  null
  
)

export default component.exports